import apiCall from "./axios_instance";
import config from '../config.json';
const { TenantId } = config;



export async function getAnnouncements(exchange, page, items, jtenantToken) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${exchange}/${page}/${items}/GetAnnoucementsData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": jtenantToken,
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in getAnnouncements API ->", error.message);
    }
}


export async function getEvents(startDate, endDate, exchangeType, jtenantToken) {

    try {
        let objResp = await apiCall.get(`cds/${TenantId}/v1/${startDate}/${endDate}/${exchangeType}/25/1/10/GetMarketEventData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": jtenantToken
            },
            noEncrypt: true,
            guestAllowed:true
        });
        //IF API NOT WORKS
        // let objResp = { data: eventsData };
        return objResp;

    } catch (error) {
        console.error(`Error in getEvents API ->", ${error.message}`);
    }
}



export async function worldIndicesData() {
    try {
        const objResp = await apiCall.get(`cds/${config.TenantId}/v1/GetWorldIndicesData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": 1
            },
            noEncrypt: true
        },
        { lock:true});
        return objResp;
    } catch (error) {
        console.error("Error in worldIndicesData API ->", error.message);
        throw error;
    }
}

export async function getNewsSectors(jtenantToken) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/-/-/GetSectorList`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": jtenantToken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in getSelectorList API ->", error.message);
    }
}


export async function getSectorwiseNews(sectorCode, page, nItems, jtenantToken) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${sectorCode}/${page}/${nItems}/GetSectorWiseNewsData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": jtenantToken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in sectorWiseNewsData API ->", error.message);
    }
}



export async function getHotPursuitData(nItems, jtenantToken) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${nItems}/GetHotPursuitData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": jtenantToken
            },
            noEncrypt: true,
            guestAllowed:true
        });
        return objResp;
    } catch (error) {
        console.error("Error in getHotPursuitData API ->", error.message);
    }
}




export async function getFIIDIIMFData(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload?.type}/GetFIIDIIMFData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in getFIIDIIMFData  API ->", error.message);
    }
}

export async function getBulkBlockDealData(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload?.exchange}/${objPayload?.dealType}/${objPayload?.fromDate}/${objPayload?.toDate}/${objPayload?.page}/${objPayload?.pagesize}/GetBulkBlockDealData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken
            },
            noEncrypt: true
        });

        return objResp;
    } catch (error) {
        console.error("Error in getBulkBlockDealData  API ->", error.message);
    }
}

export async function getMergerDemergerData(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload?.fromDate}/${objPayload?.toDate}/GetMergerDemergerData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken
            },
            noEncrypt: true
        });

        return objResp;
    } catch (error) {
        console.error("Error in GetMergerDemergerData  API ->", error.message);
    }
}





export async function companyHistory(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload.exchangeType}/${objPayload.nToken}/GetCompanyHistory`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenanttoken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in companyHistory API ->", error.message);
    }
}

export async function boardOfDirectorData(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload.exchangeType}/${objPayload.nToken}/GetBoardofDirectorData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenanttoken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in boardOfDirectorData API ->", error.message);
    }
}

export async function companyBackgroundData(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload.exchangeType}/${objPayload.nToken}/GetCompanyBackgroundData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenanttoken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in companyBackgroundData API ->", error.message);
    }
}

export async function companyListingInformation(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload.exchangeType}/${objPayload?.nToken}/GetCompanyListingInformation`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenanttoken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in companyBackgroundData API ->", error.message);
    }
}

export async function companyExchangeData(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload.exchangeType}/${objPayload.nToken}/GetCompanyExchangeData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenanttoken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in companyExchangeData API ->", error.message);
    }
}


export async function getScripWiseNewsData(odinCode, sExchange, scripNewsPage, jtenantToken) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${sExchange}/${odinCode}/${scripNewsPage}/GetScripWiseNewsData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": jtenantToken,
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in getScripWiseNewsData API ->", error.message);
    }
}


export async function getSectorWiseNewsDetails(SNo, jtenantToken) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${SNo}/GetSectorWiseNewsDetails`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": jtenantToken,
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in getSectorWiseNewsDetails API ->", error.message);
    }
}

//added by abhijeet v:2023/05/19:indices-constituents data
export async function getConstituendsDataApi(payload, jtenantToken) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${payload?.Exchange}/${payload?.IndexGroup}/${payload?.Pagesize}/GetIndexConstituentsData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": jtenantToken,
            },
            noEncrypt: true,
            guestAllowed:true,
        });
        return objResp;

    } catch (error) {
        console.error('Error in exchangeMessages API', error);
    }
}

export async function getQuarterlyTrend(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload?.exchangeType}/${objPayload?.nToken}/${objPayload?.quarterlyTend}/GetQuarterlyTrend`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken,
            },
            noEncrypt: true
        }
        );
        return objResp;
    } catch (error) {
        console.error("Error in GetQuarterlyTrend API ->", error.message);
    }
}

export async function getShareHoldingPattern(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload?.mktSegmentId}/${objPayload?.nToken}/GetShareHoldingPatternData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken,
            },
            noEncrypt: true
        }
        );
        return objResp;
    } catch (error) {
        console.error("Error in GetShareHoldingPatternData API ->", error.message);
    }
}

export async function getCompanyResult(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload?.mktSegmentId}/${objPayload?.nToken}/S/Yearly/GetCompanyResultData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken,
            },
            noEncrypt: true
        }
        );
        return objResp;
    } catch (error) {
        console.error("Error in GetCompanyResultData API ->", error.message);
    }
}
export async function getProfitLoss(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload?.exchangeType}/${objPayload?.nToken}/S/GetProfitLossData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken,
            },
            noEncrypt: true
        }
        );
        return objResp;
    } catch (error) {
        console.error("Error in GetProfitLossData API ->", error.message);
    }
}

export async function getCompanyBalanceSheet(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload?.mktSegmentId}/${objPayload?.nToken}/S/GetCompanyBalanceSheetData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken,
            },
            noEncrypt: true
        }
        );
        return objResp;
    } catch (error) {
        console.error("Error in GetCompanyBalanceSheetData API ->", error.message);
    }
}
export async function KeyStatsFinancialRatio(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload?.exchangeType}/${objPayload?.nToken}/${objPayload?.type}/GetCompanyFinancialRatioData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken,
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in KeyStatsFinancialRatio API ->", error.message);
    }
}

export async function movingAverage(objPayload) {
    try {
        //Vaibhav Singh: BT-109089: 26-10-2023: Changes accordingly wave
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload?.mktSegmentId}/${objPayload?.nToken}/GetMovingAverage?exchange_src=${objPayload?.mktSegment}`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken,
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in GetMovingAverage API ->", error.message);
    }
}


export async function scripOverviewDelivery(objPayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objPayload?.mktSegmentId}/${objPayload?.nToken}/GetVolumeVSDelivery`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken,
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in scripoverviewDelivery API ->", error.message);
    }
}
export async function getHealthTotalScore(objpayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objpayload?.exchangeType}/${objpayload?.nToken}/GetHealthTotalScore`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objpayload?.jtenantToken,
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in getHealthTotalScore API ->", error.message);
    }
}

export async function getPeerComparison(objpayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objpayload?.mktSegmentId}/${objpayload?.nToken}/GetPeerComparison`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objpayload?.jtenantToken,
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in getPeerComparison API ->", error.message);
    }
}

export async function getHealthParamScore(objpayload) {
    try {
        //BT-109089 : Vaibhav Singh : Keystats changes : Note: Need to be updated once API creation from Indresh is done and later on need to be changed 
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objpayload?.mktSegmentId}/${objpayload?.nToken}/GetHealthParamValues`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objpayload?.jtenantToken,
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in getHealthParamScore API ->", error.message);
    }
}

export async function getHealthParamValues(objpayload) {
    try {
        //BT-109089 : Vaibhav Singh : Keystats changes : Note: Need to be updated once API creation from Indresh is done and later on need to be changed 
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objpayload?.mktSegmentId}/${objpayload?.nToken}/GetHealthParamScore`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objpayload?.jtenantToken,
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in getHealthParamValues API ->", error.message);
    }
}

//Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - Start
export async function getCmotsIpo(objpayload) {
    try {
        const objResp = await apiCall.get(`cds/${TenantId}/v1/${objpayload.type}/${objpayload.pageNo}/${objpayload.pageSize}/GetIPOData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objpayload?.jtenantToken,
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in getCmotsIpo API ->", error.message);
    }
}
//Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - End

//MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info -events - Start

export async function getBoardMeetingsData(objPayload) {
    try {
        const objResp = await apiCall.get(`/cds/${TenantId}/v1/${objPayload?.exchange}/${objPayload?.token}/${objPayload?.fromDate}/${objPayload?.toDate}/${objPayload?.page}/${objPayload?.pagesize}/GetBoardMeetingsData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in GetBoardMeetingsData  API ->", error.message);
    }
}

export async function getBookClosure(objPayload) {
    try {
        const objResp = await apiCall.get(`/cds/${TenantId}/v1/${objPayload?.exchange}/${objPayload?.token}/GetBookClosure`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in GetBookClosure  API ->", error.message);
    }
}
// {{hosturl}}/cds/{{tenantid}}/v1/:Mode/:FromDate/:ToDate/:MarketSegmentId/:Token/:PageNo/:Pagesize/GetAGMEGMData
export async function getAGMEGMData(objPayload) {
    try {
        const objResp = await apiCall.get(`/cds/${TenantId}/v1/${objPayload?.mode}/${objPayload?.fromDate}/${objPayload?.toDate}/${objPayload?.exchange}/${objPayload?.token}/${objPayload?.page}/${objPayload?.pagesize}/GetAGMEGMData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in GetBoardMeetingsData  API ->", error.message);
    }
}

export async function getSpiltstData(objPayload) {
    try {
        const objResp = await apiCall.get(`/cds/${TenantId}/v1/${objPayload?.exchange}/${objPayload?.token}/${objPayload?.fromDate}/${objPayload?.toDate}/${objPayload?.recordSize}/GetSpiltstData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in GetBoardMeetingsData  API ->", error.message);
    }
}

export async function getDividentData(objPayload) {
    try {
        const objResp = await apiCall.get(`/cds/${TenantId}/v1/${objPayload?.exchange}/${objPayload?.token}/${objPayload?.fromDate}/${objPayload?.toDate}/${objPayload?.recordSize}/GetDividentData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in GetDividentData  API ->", error.message);
    }
}

export async function getBuyBack(objPayload) {
    try {
        const objResp = await apiCall.get(`/cds/${TenantId}/v1/${objPayload?.exchange}/${objPayload?.token}/GetBuyBack`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in GetBuyBack  API ->", error.message);
    }
}

export async function getRightsData(objPayload) {
    try {
        const objResp = await apiCall.get(`/cds/${TenantId}/v1/${objPayload?.exchange}/${objPayload?.token}/GetRightsData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in GetRightsData  API ->", error.message);
    }
}

export async function getBonusData(objPayload) {
    try {
        const objResp = await apiCall.get(`/cds/${TenantId}/v1/${objPayload?.exchange}/${objPayload?.token}/${objPayload?.fromDate}/${objPayload?.toDate}/${objPayload?.recordSize}/GetBonusData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in GetBoardMeetingsData  API ->", error.message);
    }
}

export async function getPremiumDiscount(objPayload) {
    try {
        const objResp = await apiCall.get(`/cds/${TenantId}/v1/${objPayload?.statusMode}/-/${objPayload?.pageNo}/${objPayload?.pageSize}/GetPremiumDiscountData`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in getPremiumDiscount  API ->", error.message);
    }
}

export async function getNearestToBookValue(objPayload) {
    try {
        const objResp = await apiCall.get(`/cds/${TenantId}/v1/-/${objPayload?.pageSize}/GetNearestToBookValue`, {
            headers: {
                "jtenantid": TenantId,
                "jtenanttoken": objPayload?.jtenantToken
            },
            noEncrypt: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in getPremiumDiscount  API ->", error.message);
    }
}
//MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info-events - End



